
export class NotificationDetailsDialogInput
{
	id: string;
	type: string;
	setAsRead: boolean;

	constructor(id: string, type: string, setAsRead: boolean)
	{
		this.id = id;
		this.type = type;
		this.setAsRead = setAsRead;
	}
}